import {Component, ElementRef, Input, ViewChild} from "@angular/core";
import {StoreData} from "../store-search.model";

/**
 * Store Map Panel component.
 */
@Component({
    selector: "woa-store-map-panel",
    templateUrl: "store-map-panel.component.html"
})
export class StoreMapPanelComponent {
    @Input() store: StoreData;
    @Input() circleMap: boolean;

    @ViewChild("map") private map: ElementRef;

    readonly key: string = "AIzaSyAL_NSSjWi-Xl1giRo__D3C6WegGLU_8yE";

    get mapImageSrc(): string {
        const width: number = this.map.nativeElement.offsetWidth;
        const height: number = this.map.nativeElement.offsetHeight;
        // noinspection SpellCheckingInspection
        return "https://maps.googleapis.com/maps/api/staticmap" +
            "?size=" + width + "x" + height +
            "&scale=2" +
            "&maptype=roadmap" +
            "&center=" + this.store.latitude + "," + this.store.longitude +
            "&markers=size:mid%7C" + this.store.latitude + "," + this.store.longitude +
            "&zoom=15" +
            "&key=" + this.key;
    }
}



// WEBPACK FOOTER //
// ./src/app/store/store-map-panel/store-map-panel.component.ts